// src/features/dashboard/mocks/productivityChart.mock.ts

import type {
  ProductivityChartApiResponse,
  ProductivityChartItem,
} from '../types/productivityChart.types';

/**
 * MOCK API RESPONSE
 */
export const productivityChartMockData: ProductivityChartApiResponse[] = [
  {
    teamLeadName: 'John Smith',
    productivePercent: 72,
    neutralPercent: 18,
    idleAwayPercent: 10,
    productiveColorHex: '#22C55E',
    neutralColorHex: '#FACC15',
    idleAwayColorHex: '#EF4444',
  },
  {
    teamLeadName: 'David Wilson',
    productivePercent: 68,
    neutralPercent: 20,
    idleAwayPercent: 12,
    productiveColorHex: '#22C55E',
    neutralColorHex: '#FACC15',
    idleAwayColorHex: '#EF4444',
  },
  {
    teamLeadName: 'Sarah Jones',
    productivePercent: 81,
    neutralPercent: 11,
    idleAwayPercent: 8,
    productiveColorHex: '#22C55E',
    neutralColorHex: '#FACC15',
    idleAwayColorHex: '#EF4444',
  },
  {
    teamLeadName: 'Michael Brown',
    productivePercent: 76,
    neutralPercent: 15,
    idleAwayPercent: 9,
    productiveColorHex: '#22C55E',
    neutralColorHex: '#FACC15',
    idleAwayColorHex: '#EF4444',
  },
];

export const mapProductivityChartData = (
  response: ProductivityChartApiResponse[],
): ProductivityChartItem[] => {

  return response.map((item) => ({
    name: item.teamLeadName.replace(
      ' ',
      '\n',
    ),

    productive: item.productivePercent,

    neutral: item.neutralPercent,

    idle: item.idleAwayPercent,

    productiveColor:
      item.productiveColorHex,

    neutralColor:
      item.neutralColorHex,

    idleColor:
      item.idleAwayColorHex,
  }));
};